import { ENUM_CHAT_MODE } from "../../components/common/enums.js";
import { useAppSelector } from "../../store/index.ts";

export default function useActiveChatMode() {
  const chatActiveMode = useAppSelector((state) => state.chat.chatActiveMode);
  const isPrivate = [ENUM_CHAT_MODE.exclusive, ENUM_CHAT_MODE.private].includes(chatActiveMode);

  return { chatActiveMode, isPrivate };
}
